module.exports = __webpack_public_path__ + "img/dd_20180109110031.22bfb148.jpg";